import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { Container, Row, Col } from 'reactstrap';
import { Field, reduxForm, formValueSelector, change } from 'redux-form/immutable';
import { dias } from 'core/constants';

import * as validations from 'modules/forms/validations';
import { FORM_RUTINAS } from 'modules/forms/formConstants';
import { TextFieldF, TimePickerF, ToggleFieldF, AutoCompleteF, CheckBoxFieldF } from 'modules/forms/component';

import * as rutinasActions from 'modules/rutinas/action';
import * as trayectosActions from 'modules/trayectos/action';
import * as gruposActions from 'modules/grupos/action';
import * as vehiculosActions from 'modules/vehiculos/action';
import * as preciosActions from 'modules/precios/action';
import * as generalActions from 'modules/general/action';

import { PenalizacionCancelacionC } from 'modules/rutinas/component';
import { CancelarButtonC } from 'modules/general/component';
import { listFindByMapId } from 'core/generalFunctions';

moment.locale('es');

const selector = formValueSelector(FORM_RUTINAS);
const hoy = moment();

const DatosTab = (props) => {
  let { trayectos, choferes, vehiculos, precios } = props;

  const selectNinguno = [
    {
      nombre: 'Ninguno',
      id: false,
    },
  ];
  trayectos = trayectos && trayectos.toJS ? trayectos.toJS() : [];
  trayectos = trayectos.map((trayecto) => ({
    nombre: trayecto.subnombre ? trayecto.nombre + ' - ' + trayecto.subnombre : trayecto.nombre,
    id: trayecto.id,
  }));

  vehiculos = vehiculos && vehiculos.toJS ? vehiculos.toJS() : [];
  vehiculos = selectNinguno.concat(
    vehiculos.map((vehiculo) => {
      let nombre = vehiculo.nombre;
      if (vehiculo.patente) nombre += ' - ' + vehiculo.patente;
      return { id: vehiculo.id, nombre: nombre };
    }),
  );

  choferes = choferes && choferes.toJS ? choferes.toJS() : [];
  choferes = selectNinguno.concat(
    choferes.map((chofer) => {
      let nombre = chofer.nombre;
      if (chofer.apellido) nombre += ' - ' + chofer.apellido;
      if (chofer.documento) nombre += ' - ' + chofer.documento;
      return { id: chofer.id, nombre: nombre };
    }),
  );

  precios = precios && selectNinguno.concat(precios.map((precio) => ({ id: precio.get('id'), nombre: precio.get('nombre') + ' - $' + precio.get('precio') })).toJS());

  return (
    <div className="p-lr-10">
      <Field
        name="trayectoId"
        component={AutoCompleteF}
        inputProps={{
          openOnFocus: true,
          fullWidth: true,
          dataSource: trayectos,
          hintText: 'Seleccione el trayecto',
          floatingLabelText: 'Trayecto',
          dataSourceConfig: { text: 'nombre', value: 'id' },
          menuStyle: {
            maxHeight: 300,
            overflow: 'auto',
          },
          filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
        }}
        onBlur={(e) => e.preventDefault()}
        validate={[validations.required, validations.noObject]}
      />
      <Field
        name="horario"
        component={TimePickerF}
        inputProps={{
          autoOk: true,
          format: '24hr',
          fullWidth: true,
          hintText: 'Hora de salida',
          floatingLabelText: 'Horario salida',
        }}
        format={(value) => (typeof value == 'string' ? null : value)}
        validate={validations.required}
      />
      <Row>
        <Col md="6">
          <Field
            name="cantAsientos"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Cantidad asientos',
              hintText: 'Cantidad  Asientos',
            }}
            validate={validations.number}
          />
        </Col>
        <Col md="6">
          <Field
            name="admitirAcompanantes"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Cantidad maxima admitada de acompañantes',
              floatingLabelStyle: { fontSize: '0.8rem' },
              hintText: 'Número de acompañantes',
            }}
            validate={validations.number}
          />
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <Field
            name="admitirCambioParadasHastaMinutosPrevios"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Límite de minutos previos para cambiar paradas',
              hintText: 'Minutos previos',
              floatingLabelStyle: { fontSize: '0.8rem' },
            }}
            validate={validations.number}
          />
        </Col>
        <Col md="6">
          <Field
            name="admitirReservasHastaMinutosPrevios"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Límite de minutos previos para admitir reservas',
              hintText: 'Minutos previos',
              floatingLabelStyle: { fontSize: '0.8rem' },
            }}
            validate={validations.number}
          />
        </Col>
        <Col md="12">
          {choferes && (
            <Field
              name="choferId"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                openOnFocus: true,
                dataSource: choferes,
                hintText: 'Chofer',
                floatingLabelText: 'Chofer',
                dataSourceConfig: { text: 'nombre', value: 'id' },
                filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                onClick: (event) => event.target.select(),
              }}
              onBlur={(e) => e.preventDefault()}
              validate={[validations.noObject]}
            />
          )}
          {vehiculos && (
            <Field
              name="vehiculoId"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                openOnFocus: true,
                dataSource: vehiculos,
                hintText: 'Vehiculo',
                floatingLabelText: 'Vehiculo',
                dataSourceConfig: { text: 'nombre', value: 'id' },
                filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                onClick: (event) => event.target.select(),
              }}
              onBlur={(e) => e.preventDefault()}
              validate={[validations.noObject]}
            />
          )}
          {precios && (
            <Field
              name="precioBoletoId"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                openOnFocus: true,
                dataSource: precios,
                hintText: 'Precio',
                floatingLabelText: 'Precio',
                dataSourceConfig: { text: 'nombre', value: 'id' },
                filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                onClick: (event) => event.target.select(),
              }}
              onBlur={(e) => e.preventDefault()}
              validate={[validations.noObject]}
            />
          )}
        </Col>
      </Row>

      <Field
        name="publico"
        component={ToggleFieldF}
        inputProps={{
          label: 'Viajes publicos',
          className: 'fullWidthComponent p10 mt-20',
        }}
      />
      <MaterialUI.Divider />
      <Field
        name="reservable"
        component={ToggleFieldF}
        inputProps={{
          label: 'Admite reservas',
          className: 'fullWidthComponent p10 mt-20',
        }}
      />
      <MaterialUI.Divider />
      <Field
        name="RALibres"
        component={ToggleFieldF}
        inputProps={{
          label: 'Reservas automaticas libres',
          className: 'fullWidthComponent p10 mt-20',
        }}
      />
      <MaterialUI.Divider />
      <Field
        name="forzarReporte"
        component={ToggleFieldF}
        inputProps={{
          label: 'Reporte chofer obligatorio',
          className: 'fullWidthComponent p10  mt-20',
        }}
      />
      <MaterialUI.Divider />
    </div>
  );
};

const ViajesTab = (props) => {
  const { publico, rutinaId, gruposList, gruposRutina, aplicarGruposAViajes, seleccionGrupo } = props;
  return (
    <div>
      <MaterialUI.Divider className="mb-10" />
      {!publico && gruposList.size > 0 && (
        <div className="p-lr-10">
          <MaterialUI.Tabs className="p-lr-10">
            <MaterialUI.Tab label="Grupos" className="p-lr-10">
              {gruposList.map((grupo) => (
                <div className="p-lr-10" key={grupo.get('id')}>
                  <MaterialUI.Divider className="mb-10" />
                  <MaterialUI.Toggle
                    toggled={gruposRutina && gruposRutina.findIndex((i) => i === grupo.get('id')) !== -1}
                    onToggle={(e, a) => seleccionGrupo(grupo.get('id'), a)}
                    label={grupo.get('nombre')}
                  />
                </div>
              ))}
            </MaterialUI.Tab>
          </MaterialUI.Tabs>
        </div>
      )}
      {publico && <div className="textCenter">Los viajes creados seran visibles para todos los pasajeros.</div>}
      <MaterialUI.Divider className="padding mt-20" />
      {rutinaId !== 'new' && (
        <Col md="12">
          <MaterialUI.RaisedButton
            onClick={aplicarGruposAViajes}
            secondary={true}
            label={publico ? 'HACER PUBLICOS LOS VIAJES DE LA RUTINA QUE NO LO SEAN' : 'APLICAR GRUPOS A TODOS LOS VIAJES DE ESTA RUTINA'}
            className="fullWidthComponent noPadding m-tb-20"
          />
        </Col>
      )}
    </div>
  );
};

const VisibilidadTab = ({ publico, gruposList, gruposRutina, seleccionGrupo, aplicarGruposAViajes, rutinaId }) => (
  <div>
    <Field
      name="publico"
      component={ToggleFieldF}
      inputProps={{
        label: 'Viajes publicos',
        className: 'fullWidthComponent p10',
      }}
    />
    <MaterialUI.Divider className="padding" />
    {!publico && gruposList.size > 0 && (
      <div className="p-lr-10">
        <MaterialUI.Tabs className="p-lr-10">
          <MaterialUI.Tab label="Grupos" className="p-lr-10">
            {gruposList.map((grupo) => (
              <div className="p-lr-10" key={grupo.get('id')}>
                <MaterialUI.Divider className="mb-10" />
                <MaterialUI.Toggle
                  toggled={gruposRutina && gruposRutina.findIndex((i) => i === grupo.get('id')) !== -1}
                  onToggle={(e, a) => seleccionGrupo(grupo.get('id'), a)}
                  label={grupo.get('nombre')}
                />
              </div>
            ))}
          </MaterialUI.Tab>
        </MaterialUI.Tabs>
      </div>
    )}
    {publico && <div className="textCenter pt-20">Los viajes creados seran visibles para todos los pasajeros.</div>}
    <MaterialUI.Divider className="padding mt-20" />
    {rutinaId !== 'new' && (
      <Col md="12">
        <MaterialUI.RaisedButton
          onClick={aplicarGruposAViajes}
          secondary={true}
          label={publico ? 'HACER PUBLICOS LOS VIAJES DE LA RUTINA QUE NO LO SEAN' : 'APLICAR GRUPOS A TODOS LOS VIAJES DE ESTA RUTINA'}
          className="fullWidthComponent noPadding m-tb-20"
        />
      </Col>
    )}
  </div>
);

class Add extends React.Component {
  componentDidMount() {
    this.props.dispatch(trayectosActions.get());
    this.props.dispatch(gruposActions.get());
    this.props.dispatch(vehiculosActions.get());
    this.props.dispatch(vehiculosActions.seleccionarChofer());
    this.props.dispatch(preciosActions.getActivos());
    if (this.props.params.rutinaId == 'new') this.props.dispatch(generalActions.dashboard_changeTitle('NUEVA RUTINA'));
    else {
      this.props.dispatch(rutinasActions.getById(this.props.params.rutinaId));
      this.props.dispatch(generalActions.dashboard_changeTitle('MODIFICAR RUTINA'));
    }
  }
  componentWillUnmount = () => this.props.dispatch(rutinasActions.clear('rutina'));
  submitForm = (data) => {
    const { gruposRutina } = this.props;
    const formSendData = formatData(data.toJS(), gruposRutina);
    this.props.dispatch(rutinasActions.set(formSendData, this.props.params.rutinaId));
  };
  selectAll = (type) => {
    dias.map((dia, i) => {
      if (type == 'todos') this.props.change(dia, true);
      else if (i == 0 || i == 6) this.props.change(dia, false);
      else this.props.change(dia, true);
    });
  };
  aplicarGruposAViajes = () => {
    const { gruposRutina } = this.props;
    if (this.props.params.rutinaId !== 'new') this.props.dispatch(rutinasActions.aplicarGruposAViajes(this.props.params.rutinaId, gruposRutina));
  };
  aplicarCambiosAViajes = (data) => {
    const formSendData = data && data.toJS && formatData(data.toJS());
    if (this.props.params.rutinaId !== 'new') this.props.dispatch(rutinasActions.aplicarCambiosAViajes({ ...formSendData, rutinaId: this.props.params.rutinaId }));
  };
  seleccionGrupo = (grupo, agregar) => this.props.dispatch(rutinasActions.setGrupo(grupo, agregar));
  render = () => {
    const {
      reservable,
      precioBoletoId,
      penalizacionCancelacionCosto,
      penalizacionCancelacionPorcentaje,
      publico,
      gruposList,
      gruposRutina,
      params: { rutinaId },
    } = this.props;
    console.log('publico', publico);
    return (
      <Container fluid={true}>
        <form onSubmit={this.props.handleSubmit(this.submitForm)}>
          <Row>
            <Col md={{ size: 7 }}>
              <MaterialUI.Paper zDepth={2} className="padding">
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Datos">
                    <DatosTab {...this.props} />
                  </MaterialUI.Tab>
                  <MaterialUI.Tab label="Penalizacion">
                    <PenalizacionCancelacionC
                      penalizacionCancelacionCosto={penalizacionCancelacionCosto}
                      penalizacionCancelacionPorcentaje={penalizacionCancelacionPorcentaje}
                      reservable={reservable}
                      precios={this.props.precios}
                      precioBoletoId={precioBoletoId}
                    />
                  </MaterialUI.Tab>
                  <MaterialUI.Tab label="Visibilidad">
                    <VisibilidadTab
                      publico={publico}
                      gruposList={gruposList}
                      gruposRutina={gruposRutina}
                      seleccionGrupo={this.seleccionGrupo}
                      aplicarGruposAViajes={this.aplicarGruposAViajes}
                      rutinaId={rutinaId}
                    />
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
            <Col md="4">
              <MaterialUI.Paper zDepth={1}>
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Dias">
                    <MaterialUI.RaisedButton primary label="Todos" onClick={() => this.selectAll('todos')} className="halfWidthComponent noPadding" />
                    <MaterialUI.RaisedButton primary onClick={() => this.selectAll('no')} label="Dias laborales" className="halfWidthComponent noPadding" />
                    <MaterialUI.List name="dias" style={{ maxHeight: 350, overflow: 'auto' }}>
                      <MaterialUI.ListItem
                        className="noPadding textCenter"
                        leftCheckbox={
                          <Field
                            name="domingo"
                            inputProps={{
                              label: 'Domingo',
                            }}
                            component={CheckBoxFieldF}
                          />
                        }
                      />
                      <MaterialUI.ListItem className="noPadding textCenter" leftCheckbox={<Field name="lunes" inputProps={{ label: 'Lunes' }} component={CheckBoxFieldF} />} />
                      <MaterialUI.ListItem className="noPadding textCenter" leftCheckbox={<Field name="martes" inputProps={{ label: 'Martes' }} component={CheckBoxFieldF} />} />
                      <MaterialUI.ListItem className="noPadding textCenter" leftCheckbox={<Field name="miercoles" inputProps={{ label: 'Miercoles' }} component={CheckBoxFieldF} />} />
                      <MaterialUI.ListItem className="noPadding textCenter" leftCheckbox={<Field name="jueves" inputProps={{ label: 'Jueves' }} component={CheckBoxFieldF} />} />
                      <MaterialUI.ListItem className="noPadding textCenter" leftCheckbox={<Field name="viernes" inputProps={{ label: 'Viernes' }} component={CheckBoxFieldF} />} />
                      <MaterialUI.ListItem className="noPadding textCenter" leftCheckbox={<Field name="sabado" inputProps={{ label: 'Sabado' }} component={CheckBoxFieldF} />} />
                      <MaterialUI.Divider className="mb-10" />
                      <Field
                        name="feriado"
                        component={ToggleFieldF}
                        inputProps={{
                          label: 'Feriados',
                          className: 'fullWidthComponent p10',
                        }}
                      />
                    </MaterialUI.List>
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
          </Row>
          <Col md="12">
            {rutinaId !== 'new' && (
              <MaterialUI.RaisedButton
                onClick={this.props.handleSubmit(this.aplicarCambiosAViajes)}
                secondary={true}
                label="CAMBIAR DATOS EN TODOS LOS VIAJES DE ESTA RUTINA"
                className="fullWidthComponent noPadding m-tb-20"
              />
            )}
            <MaterialUI.RaisedButton type="submit" primary={true} label="GUARDAR" className="fullWidthComponent noPadding m-tb-20" />
            <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />
          </Col>
        </form>
      </Container>
    );
  };
}

const formatData = (data, gruposRutina) => {
  let dataClon = Object.assign({}, data);
  dataClon.horario = moment(data.horario).format('HH:mm');
  dataClon.grupos = gruposRutina;
  if (dataClon.cantAsientos) dataClon.cantAsientos = parseInt(dataClon.cantAsientos);
  if (dataClon.penalizacionCancelacionMinutosPrevios) dataClon.penalizacionCancelacionMinutosPrevios = parseInt(dataClon.penalizacionCancelacionMinutosPrevios);
  if (dataClon.admitirAcompanantes) dataClon.admitirAcompanantes = parseInt(dataClon.admitirAcompanantes);
  if (dataClon.admitirCambioParadasHastaMinutosPrevios) dataClon.admitirCambioParadasHastaMinutosPrevios = parseInt(dataClon.admitirCambioParadasHastaMinutosPrevios);
  if (dataClon.admitirReservasHastaMinutosPrevios) dataClon.admitirReservasHastaMinutosPrevios = parseInt(dataClon.admitirReservasHastaMinutosPrevios);

  if (dataClon.penalizacionCancelacionCosto === '') delete dataClon.penalizacionCancelacionCosto;
  else if (dataClon.penalizacionCancelacionCosto) dataClon.penalizacionCancelacionCosto = parseInt(dataClon.penalizacionCancelacionCosto);
  if (dataClon.penalizacionCancelacionPorcentaje === '') delete dataClon.penalizacionCancelacionPorcentaje;
  else if (dataClon.penalizacionCancelacionPorcentaje) dataClon.penalizacionCancelacionPorcentaje = parseInt(dataClon.penalizacionCancelacionPorcentaje);

  return dataClon;
};

Add = reduxForm({
  form: FORM_RUTINAS,
  enableReinitialize: true,
})(Add);

Add = connect((store) => {
  let horario = store.getIn(['rutinas', 'rutina', 'horario']);
  const reservable = store.getIn(['rutinas', 'rutina', 'reservable']);
  const publico = store.getIn(['rutinas', 'rutina', 'publico']);
  if (horario) {
    horario = horario.split(':');
    horario = hoy.hour(horario[0]).minute(horario[1]).toDate();
  }
  return {
    trayectos: store.getIn(['trayectos', 'lista']),
    useParadasTrayecto: selector(store, 'usarParadasTrayecto'),
    publico: selector(store, 'publico'),
    gruposList: store.getIn(['grupos', 'lista']),
    gruposRutina: store.getIn(['rutinas', 'rutina', 'grupos']),
    vehiculos: store.getIn(['vehiculos', 'lista']),
    choferes: store.getIn(['general', 'seleccionador', 'listas', '_chofer']),
    precios: store.getIn(['general', 'seleccionador', 'listas', 'precios']),
    penalizacionCancelacionPorcentaje: selector(store, 'penalizacionCancelacionPorcentaje'),
    penalizacionCancelacionCosto: selector(store, 'penalizacionCancelacionCosto'),
    precioBoletoId: selector(store, 'precioBoletoId'),
    reservable: selector(store, 'reservable'),
    initialValues: {
      horario,
      lunes: store.getIn(['rutinas', 'rutina', 'lunes']),
      martes: store.getIn(['rutinas', 'rutina', 'martes']),
      miercoles: store.getIn(['rutinas', 'rutina', 'miercoles']),
      jueves: store.getIn(['rutinas', 'rutina', 'jueves']),
      sabado: store.getIn(['rutinas', 'rutina', 'sabado']),
      domingo: store.getIn(['rutinas', 'rutina', 'domingo']),
      viernes: store.getIn(['rutinas', 'rutina', 'viernes']),
      feriado: store.getIn(['rutinas', 'rutina', 'feriado']),
      RALibres: store.getIn(['rutinas', 'rutina', 'RALibres']),
      reservable: Boolean(reservable),
      publico: Boolean(publico),
      choferId: store.getIn(['rutinas', 'rutina', 'choferId']),
      vehiculoId: store.getIn(['rutinas', 'rutina', 'vehiculoId']),
      trayectoId: store.getIn(['rutinas', 'rutina', 'trayectoId']),
      precioBoletoId: store.getIn(['rutinas', 'rutina', 'precioBoletoId']),
      cantAsientos: store.getIn(['rutinas', 'rutina', 'cantAsientos']) || '19',
      forzarReporte: store.getIn(['rutinas', 'rutina', 'forzarReporte']),
      admitirReservasHastaMinutosPrevios: store.getIn(['rutinas', 'rutina', 'admitirReservasHastaMinutosPrevios']),
      admitirCambioParadasHastaMinutosPrevios: store.getIn(['rutinas', 'rutina', 'admitirCambioParadasHastaMinutosPrevios']),
      admitirAcompanantes: store.getIn(['rutinas', 'rutina', 'admitirAcompanantes']),
      penalizacionCancelacionCosto: store.getIn(['rutinas', 'rutina', 'penalizacionCancelacionCosto']),
      penalizacionCancelacionPorcentaje: store.getIn(['rutinas', 'rutina', 'penalizacionCancelacionPorcentaje']),
      penalizacionCancelacionMinutosPrevios: store.getIn(['rutinas', 'rutina', 'penalizacionCancelacionMinutosPrevios']),
    },
  };
})(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/rutinas/components/add.js